import { render, staticRenderFns } from "./homeAdvert.vue?vue&type=template&id=13bd5854&scoped=true&"
import script from "./homeAdvert.vue?vue&type=script&lang=js&"
export * from "./homeAdvert.vue?vue&type=script&lang=js&"
import style0 from "./homeAdvert.vue?vue&type=style&index=0&id=13bd5854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd5854",
  null
  
)

export default component.exports